import { render, staticRenderFns } from "./AnswerAI.vue?vue&type=template&id=ffbde908&scoped=true&"
import script from "./AnswerAI.vue?vue&type=script&lang=js&"
export * from "./AnswerAI.vue?vue&type=script&lang=js&"
import style0 from "./AnswerAI.vue?vue&type=style&index=0&id=ffbde908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbde908",
  null
  
)

export default component.exports